var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { deferred } from 'fast-defer';
import { createValidateStatus, isMethodIn, setRevalidationHeaders } from './util';
export function defaultRequestInterceptor(axios) {
    var _this = this;
    var onFulfilled = function (config) { return __awaiter(_this, void 0, void 0, function () {
        var key, cache, cachedResponse, deferred_1, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (config.cache === false) {
                        return [2 /*return*/, config];
                    }
                    // merge defaults with per request configuration
                    config.cache = __assign(__assign({}, axios.defaults.cache), config.cache);
                    if (!isMethodIn(config.method, config.cache.methods)) {
                        return [2 /*return*/, config];
                    }
                    key = axios.generateKey(config);
                    return [4 /*yield*/, axios.storage.get(key)];
                case 1:
                    cache = _c.sent();
                    if (!(cache.state == 'empty' || cache.state === 'stale')) return [3 /*break*/, 5];
                    if (!axios.waiting[key]) return [3 /*break*/, 3];
                    return [4 /*yield*/, axios.storage.get(key)];
                case 2:
                    cache = (_c.sent());
                    return [3 /*break*/, 5];
                case 3:
                    // Create a deferred to resolve other requests for the same key when it's completed
                    axios.waiting[key] = deferred();
                    /**
                     * Add a default reject handler to catch when the request is aborted without others
                     * waiting for it.
                     */
                    (_b = axios.waiting[key]) === null || _b === void 0 ? void 0 : _b.catch(function () { return undefined; });
                    return [4 /*yield*/, axios.storage.set(key, {
                            state: 'loading',
                            data: cache.data
                        })];
                case 4:
                    _c.sent();
                    if (cache.state === 'stale') {
                        setRevalidationHeaders(cache, config);
                    }
                    config.validateStatus = createValidateStatus(config.validateStatus);
                    return [2 /*return*/, config];
                case 5:
                    if (!(cache.state === 'loading')) return [3 /*break*/, 11];
                    deferred_1 = axios.waiting[key];
                    if (!!deferred_1) return [3 /*break*/, 7];
                    return [4 /*yield*/, axios.storage.remove(key)];
                case 6:
                    _c.sent();
                    return [2 /*return*/, config];
                case 7:
                    _c.trys.push([7, 9, , 10]);
                    return [4 /*yield*/, deferred_1];
                case 8:
                    cachedResponse = _c.sent();
                    return [3 /*break*/, 10];
                case 9:
                    _a = _c.sent();
                    // The deferred is rejected when the request that we are waiting rejected cache.
                    return [2 /*return*/, config];
                case 10: return [3 /*break*/, 12];
                case 11:
                    cachedResponse = cache.data;
                    _c.label = 12;
                case 12:
                    config.adapter = function () {
                        /**
                         * Even though the response interceptor receives this one from here, it has been
                         * configured to ignore cached responses: true
                         */
                        return Promise.resolve({
                            config: config,
                            data: cachedResponse.data,
                            headers: cachedResponse.headers,
                            status: cachedResponse.status,
                            statusText: cachedResponse.statusText,
                            cached: true,
                            id: key
                        });
                    };
                    return [2 /*return*/, config];
            }
        });
    }); };
    return {
        onFulfilled: onFulfilled,
        apply: function () { return axios.interceptors.request.use(onFulfilled); }
    };
}
